import React, { useState } from "react";
import { Bell, Search, Moon, Sun } from "../../utils/icons";
import { useTheme } from "../../context/ThemeContext";
import Avatar from "../ui/Avatar";
import Badge from "../ui/Badge";

const notifications = [
  {
    id: 1,
    text: "New user signed up: Marcus Webb",
    time: "2m ago",
    unread: true,
  },
  {
    id: 2,
    text: "Revenue milestone: $50k MRR reached!",
    time: "1h ago",
    unread: true,
  },
  {
    id: 3,
    text: "Scheduled maintenance on Apr 10",
    time: "3h ago",
    unread: false,
  },
];

const Topbar = ({ collapsed }) => {
  const { dark, toggle } = useTheme();
  const [showNotifications, setShowNotifications] = useState(false);
  const [search, setSearch] = useState("");
  const unreadCount = notifications.filter((n) => n.unread).length;

  return (
    <header
      className={`fixed top-0 right-0 z-20 h-16 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between px-4 gap-4 transition-all duration-300 ${collapsed ? "left-16" : "left-60"}`}
    >
      <div className="relative flex-1 max-w-sm">
        <Search
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search anything..."
          className="input-field !py-2 !pl-9 text-sm"
        />
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={toggle}
          className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-600 dark:text-gray-400"
        >
          {dark ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-600 dark:text-gray-400"
          >
            <Bell size={18} />
            {unreadCount > 0 && (
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
            )}
          </button>

          {showNotifications && (
            <div className="absolute right-0 top-12 w-80 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl shadow-2xl animate-fade-up overflow-hidden">
              <div className="p-4 border-b border-gray-100 dark:border-gray-800 flex justify-between items-center">
                <span className="font-semibold font-display text-gray-900 dark:text-white">
                  Notifications
                </span>
                <Badge color="primary">{unreadCount} new</Badge>
              </div>
              {notifications.map((n) => (
                <div
                  key={n.id}
                  className={`p-4 border-b border-gray-50 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer ${n.unread ? "bg-primary-50/50 dark:bg-primary-900/10" : ""}`}
                >
                  <p className="text-sm text-gray-800 dark:text-gray-200">
                    {n.text}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">{n.time}</p>
                </div>
              ))}
              <div className="p-3 text-center">
                <button className="text-sm text-primary-600 dark:text-primary-400 hover:underline font-medium">
                  View all notifications
                </button>
              </div>
            </div>
          )}
        </div>

        <button className="flex items-center gap-2 pl-2">
          <Avatar name="Aria Chen" size="sm" />
          <div className="hidden sm:block text-left">
            <p className="text-xs font-semibold text-gray-900 dark:text-white">
              Aria Chen
            </p>
            <p className="text-xs text-gray-500">Admin</p>
          </div>
        </button>
      </div>
    </header>
  );
};

export default Topbar;
